
import { of as observableOf,  Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '../../response';
import { IReportQuery, IGetAllReportQueries } from './reportqueries-model';
import { IExecuteReportItems } from './reportexecute-model';

@Injectable()
export class ReportQueriesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'reportqueries';

    public get(id: string): Observable<SuccessResponse<IReportQuery> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IReportQuery>>(ReportQueriesService.URL + ReportQueriesService.ENDPOINT + '/' + id).pipe(
                catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getAll(): Observable<SuccessResponse<IGetAllReportQueries> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IGetAllReportQueries>>(
                ReportQueriesService.URL +
                ReportQueriesService.ENDPOINT).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public add(query: IReportQuery): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(
                ReportQueriesService.URL  +
                ReportQueriesService.ENDPOINT, query).pipe(
                catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public update(query: IReportQuery): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                ReportQueriesService.URL +
                ReportQueriesService.ENDPOINT + '/' + query.id, query).pipe(
                catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public delete(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(
                ReportQueriesService.URL +
                ReportQueriesService.ENDPOINT + '/' + id).pipe(
                catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public execute(reportQuery: IReportQuery): Observable<SuccessResponse<boolean> | ErrorResponse> {
        const enumNames = ['undefined', 'contacts', 'events', 'invitations', 'venues'];
        return this.http
            .post<SuccessResponse<IExecuteReportItems>>(
                ReportQueriesService.URL +
                ReportQueriesService.ENDPOINT + '/execute/' + enumNames[reportQuery.reportType], reportQuery).pipe(
                catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
